/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:52
 * @LastEditTime: 2020-07-17 16:58:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/permission.js
 */
import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import { getToken } from './common/auth' // 验权
const whiteList = [
    'login',
    '500',
    '403',
    '404',
    '401',
    'register',
    'retrievePassword'
] // 不重定向白名单

// 全局路由拦截器 进入每一个路由的时候执行
router.beforeEach(async (to, from, next) => {
    // to 准备跳转的路由对象
    // fullpath 路由地址
    // name 路由名称
    // hash 哈希值
    // matched 存储的路由跳转后的历史记录
    // meta 路由跳转中的meta 传参
    // param 路由跳转的 param传参
    // query 路由跳蛛的 querys传参
    // query 传参通过浏览器的url地址是可见的,是以查询字符串的形式拼接在url服务器地址后面, 而param meta 传参是不可见的通常存储在路由对象中
    // console.log("全局路由守卫to", to)
    // from 离开时的路由对象
    // console.log("全局路由守卫from", from)
    // 允许路由跳转
    // console.log("全局路由守卫next", next)

    NProgress.start() // 开启进度条加载
    const hasToken = getToken() // 获取token信息
    // 如果要前往的页面为 登录login 或者 storeChoose
    if ((to.name != 'login' || to.name != 'storeChoose') && store.state.listDatas.length == 0) {
    } else {
        let list = store.state.listDatas
        for (let i = 0; i < list.length; i++) {
            const ele = list[i]
            if (to.name == 'workbench') {
                store.commit('set_navindex', 0)
                store.commit('set_childIndex', 0)
            } else {
                if (ele.children) {
                    for (let j = 0; j < ele.children.length; j++) {
                        try {
                            if (to.name == ele.children[j].redirect.name) {
                                store.commit('set_navindex', ele.meta.No)
                                store.commit('set_childIndex', i)
                            }
                        } catch (error) {
                            if (to.name == ele.children[j].name) {
                                store.commit('set_navindex', ele.meta.No)
                                store.commit('set_childIndex', i)
                            }
                        }
                        if (ele.children[j].children) {
                            for (let k = 0; k < ele.children[j].children.length; k++) {
                                const item = ele.children[j].children[k]

                                try {
                                    if (to.name == item.redirect.name) {
                                        store.commit('set_navindex', ele.meta.No)
                                        store.commit('set_childIndex', i)
                                    }
                                } catch (error) {
                                    if (to.name == item.name) {
                                        store.commit('set_navindex', ele.meta.No)
                                        store.commit('set_childIndex', i)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    // console.log(to.name, "toName");
    // 判断是否有token信息
    if (hasToken) {
        if (to.name === 'login' || to.name === 'register' || to.name === 'retrievePassword') {
            next({ path: '/' })
            NProgress.done()
        } else if (to.name === 'paperless') {
            // 判断当前随否开通
            let isPaperlessOffice = JSON.parse(window.localStorage.getItem('tenant')).isPaperlessOffice
            console.log('去无纸化', isPaperlessOffice)
            if (isPaperlessOffice === 1) next()
            else next({ name: 'workbench' })
        } else {
            next()
        }
        NProgress.done()
    } else {
        // 没有token信息
        // 如果跳转到不需要重定向的路由则直接放行
        if (whiteList.indexOf(to.name) !== -1) {
            next()
        } else if (to.name !== 'login') {
            next({ name: 'login' })
        } else {
            next()
            NProgress.done()
        }
    }
})

// 全局路由守卫离开这个路由时执行
router.afterEach(() => {
    NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js